import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import SearchIcon from '@mui/icons-material/Search';
import dayjs from 'dayjs';

const cardStyle = {
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
  padding: 0,
  minWidth: 0,
  marginBottom: 0,
  fontFamily: 'Poppins, sans-serif',
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 18,
};

const titleStyle = {
  fontWeight: 700,
  fontSize: 24,
  color: '#111',
  letterSpacing: 0.7,
};

const searchContainer = {
  position: 'relative',
  minWidth: 200,
  marginLeft: 8,
};

const searchInput = {
  width: 200,
  padding: '10px 36px 10px 38px',
  border: '1.5px solid #C8E6C9',
  borderRadius: 8,
  fontSize: 16,
  color: '#1B5E20',
  background: '#fff',
  fontFamily: 'inherit',
  outline: 'none',
  transition: 'border 0.3s',
};

const searchIconStyle = {
  position: 'absolute',
  left: 12,
  top: '50%',
  transform: 'translateY(-50%)',
  color: '#00C853',
  fontSize: 20,
  pointerEvents: 'none',
};

const LoginLogTable = ({ logs, loading, error }) => {
  const [search, setSearch] = useState('');

  const filteredLogs = logs.filter(log =>
    log.username && log.username.toLowerCase().includes(search.toLowerCase())
  );

  const columns = [
    { name: 'Username', selector: row => row.username.charAt(0).toUpperCase() + row.username.slice(1), sortable: true },
    { name: 'Login Date & Time', selector: row => dayjs(row.login_time).format('DD MMM YYYY, hh:mm A'), sortable: true },
  ];

  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <span style={titleStyle}>Login Logs</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={searchContainer}>
            <SearchIcon style={searchIconStyle} />
            <input
              style={searchInput}
              type="text"
              placeholder="Search username..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={filteredLogs}
        highlightOnHover
        pointerOnHover
        pagination
        noHeader
        customStyles={{
          headCells: {
            style: {
              background: '#E8F5E9',
              color: '#111',
              fontWeight: 700,
              fontSize: 17,
              borderBottom: '1.5px solid #A5D6A7',
            },
          },
          rows: {
            style: {
              minHeight: '48px',
              fontSize: 16,
              color: '#333',
              fontFamily: 'inherit',
              background: '#fff',
            },
            highlightOnHoverStyle: {
              backgroundColor: '#C8E6C9',
              borderRadius: 8,
              outline: 'none',
            },
          },
        }}
        progressPending={loading}
        progressComponent={<div style={{ padding: 16 }}>Loading...</div>}
        noDataComponent={<div style={{ padding: 16, color: '#888' }}>No logs found.</div>}
      />
      {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
    </div>
  );
};

export default LoginLogTable; 